import * as React from 'react';
import { useIntl } from '@grandvisionhq/state';
import StoreFranchiseIndicator from './StoreFranchiseIndicator.js';

const StoreFranchiseIndicatorContainer = ()=>{
    const { getFormattedLabel  } = useIntl();
    const label = getFormattedLabel('stores.page.details.franchiseStoreIndicator', {
        parseLink: true
    });
    return /*#__PURE__*/ React.createElement(StoreFranchiseIndicator, {
        label: label
    });
};

export { StoreFranchiseIndicatorContainer as default };
//# sourceMappingURL=StoreFranchiseIndicatorContainer.js.map
